import { usePlaceByCoords } from 'hooks/usePlace'

function useExperiencePlace(experience: App.ExperienceOffer) {
  const [place] = usePlaceByCoords(experience.location.latitude, experience.location.longitude)
  return place
}

export default useExperiencePlace
